

















































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { ReferralEspoedDetailsModel } from "@/types/aznconnect_api";

@Component({})
export default class Timings extends Vue {
  @Prop({ default: null })
  referral!: ReferralEspoedDetailsModel;
}
